module.exports = __webpack_public_path__ + "static/media/10.015fc6d1.jpg";